"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-cream py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="flex-1 space-y-6">
          <h1 className="text-3xl md:text-[42px] font-bold text-secondary leading-tight">
            {t("maint.h1")}
          </h1>
          <p className="text-base md:text-lg text-gray-600 max-w-xl">
            {t("maint.subhead")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+17863774452"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-orange hover:bg-orange/90 text-white font-semibold rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              Call (786) 377-4452
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-secondary text-secondary font-semibold rounded-md hover:bg-secondary hover:text-white transition-colors whitespace-nowrap"
            >
              Get Phone Quote
            </a>
          </div>
        </div>
        <div className="flex-1 flex justify-center lg:justify-end">
          <img
            src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/c2f3e806-5629-4886-a18c-d3a6a5c4c8e1_Annual-Window-Maintenance-Across-Miami-Dade.png?v=e1288bba0b94d66aa7b144713047b91a"
            alt="Annual window maintenance tune-up Miami-Dade residential"
            className="rounded-xl w-full max-w-[520px] h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}